//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscAIFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6.15854 7.14316L9.15093 1.99731H10.8799L13.8722 7.14316L19.0181 10.1356V11.8645L13.8722 14.8569L10.8799 20.0027H9.15093L6.15854 14.8569L1.0127 11.8645V10.1356L6.15854 7.14316Z" fill="currentColor" /><path d="M20.7973 18.1938L19.5164 15.9911L18.2355 18.1938L16.0327 19.4748L18.2355 20.7557L19.5164 22.9585L20.7973 20.7557L23.0001 19.4748L20.7973 18.1938Z" fill="currentColor" /></svg>;
}
export default IconMiscAIFill;